import { getCookies } from './getCookies';

export const parseCustomData = ({
  contentIds = [],
  contents = [],
  hotelCurrency = {},
  propertyName,
  ...others
} = {}) => ({
  contentIds: contentIds.map((id) => `${id}`),
  contentName: propertyName,
  contentType: 'hotel',
  contents: contentIds.length === 1 ? contents.map((content) => ({ ...content, id: `${contentIds[0]}` })) : contents,
  currency: hotelCurrency.code?.toUpperCase(),
  ...getCookies(),
  ...others,
});
